import React, { useEffect, useRef, useState } from "react";
import SimpleText from "@/components/texts/simpleText";
import Button from "@/components/inputs/button";
import {GET_ALL_STATE, GET_USER_EMAIL, SET_LOADING, SET_USER_EMAIL, SET_USER_TAB} from "@/store/slices/appSlice";
import {useDispatch, useSelector} from "react-redux";
import InputWithValidation from "@/components/inputs/inputWithValidation";
import {SET_USER_ALERT} from "@/store/slices/userSlice";
import themes from "@/styles/themes";

import ButtonLink from "@/components/inputs/buttonLink";
import Events from "@/utils/Events";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import Apm from "@/utils/Apm";
import { recoverPassword } from "@/api/assine";
import Nullable from "@/types/utils/Nullable";
import { isEmail } from "@/utils/validation";
import useRecaptcha from "@/hooks/useRecaptcha";

export default function Recuperar() {
    const events = new Events()
    const dispatch = useDispatch();
    const storedEmail = useSelector(GET_USER_EMAIL)
    const [email, setEmail] = useState(storedEmail)
    const [emailErrorMessage, setEmailErrorMessage] = useState<Nullable<string>>(null)
    const states = useSelector(GET_ALL_STATE)
    const offer_type = useSelector(GET_OFFER_TYPE)
    const recaptcha = useRecaptcha()
    const initialEmailRef = useRef(storedEmail)

    useEffect(() => {
        events.trigger("restaurar_senha_visualizado", { offer_type })
    }, [events, offer_type]);

    function setTab(idx: any) {
        dispatch(SET_USER_TAB(idx))
    }

    async function submitRefresh(event: any) {
        event.preventDefault();

    const recaptchaToken = await recaptcha.validate('REDEEM_CODE');

        if (!isEmail(email)) {
            events.trigger('restaurar_senha_erro_email', { offer_type });
            setEmailErrorMessage('Email Inválido');
            return;
        }

        if (!recaptchaToken || typeof recaptchaToken !== 'string' || recaptchaToken.trim() === '') {
            dispatch(SET_USER_ALERT({
                show: true,
                message: 'Erro de segurança: reCAPTCHA não foi validado. Tente novamente.',
                type: 'error'
            }));
            recaptcha.reset();
            return;
        }

        setEmailErrorMessage('');
        dispatch(SET_LOADING(true));
        recoverPassword({
            email: email.trim(),
            referrer_url: window.location.href,
            recaptcha: { token: recaptchaToken, action: 'REDEEM_CODE' }
        }).then(() => {
            dispatch(SET_USER_ALERT({
                show: true,
                message: "Email enviado com sucesso",
                type: 'success'
            }));
            dispatch(SET_USER_TAB(0));
            events.trigger("restaurar_senha_sucesso", { offer_type });
        }).catch((e) => {
            Apm.captureError(e);

            if (e.message && e.message.toLowerCase().includes('network')) {
                e.message = 'Erro de conexão';
            }

            dispatch(SET_USER_ALERT({
                show: true,
                message: e.message,
                type: 'error'
            }));
            recaptcha.reset();
        })
        .finally(() => {
            dispatch(SET_LOADING(false));
        });
    }

    return <>
        <ButtonLink 
            color={` ${themes.estadao} !important`}
            style={{
                textDecoration: 'underline',
                fontSize: '13px',
                margin:'6px 0'
            }}
            onClick={() => {
                dispatch(SET_USER_EMAIL(email.trim() !== '' ? email.trim() : initialEmailRef.current))
                setTab(0)
                events.trigger("restaurar_senha_voltar", { offer_type })
            }}
        >
            Voltar
        </ButtonLink>
        <form onSubmit={submitRefresh}>
            <SimpleText color={themes.greyNormal} style={{margin: "6px 0"}}>
                Preencha o campo abaixo com o e-mail da sua conta
                e receba o link para redefinir sua senha
            </SimpleText>
            <InputWithValidation 
                name="email"
                id="email"
                placeholder="E-mail"
                type="email"
                OnClick={()=> {
                    events.trigger("restaurar_senha_email", { offer_type })
                }}
                onChange={setEmail}
                errorMessage={emailErrorMessage}
                value={email}
            />
            <Button data-transaction-name="Recuperar Usuario" type={"submit"} onClick={()=>{events.trigger("restaurar_senha_enviar", { offer_type })}}>Enviar</Button>    
        </form>
    </>
}